// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__LkR6w","WECAN":"Footer_WECAN__Yi02f","links":"Footer_links__bOgXZ","info":"Footer_info__X0PKc"};